import { FilterOption } from '../../../components/_WMS/FilterComponent/types'

export const filterOptions: FilterOption[] = [
  {
    key: 'name',
    label: 'Nombre',
    type: 'text',
    order: 1
  },
  {
    key: 'active',
    label: 'Activo',
    type: 'precreated',
    order: 2
  },
  {
    key: 'typeVasId',
    label: 'Tipo VAS',
    type: 'precreated',
    order: 3
  }
]
